import * as actionTypes from "./ActionTypes"
import Auth from "auth"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer" 
let _leadName = []
let _limit = 0
let _status = 0
export const listsCustomerSurveyUpdate = (leadName = [],limit = 0 ,status = 0,useRecentCache = false,isSuccessCase = false,isSuccessQcCheck = false,isSuccessQcPass = false, startDate = null, endDate = null, dealer_code = null) => {
  return dispatch => {  
    if(
      leadName == null &&
      limit == null && 
      status == null && 
      !useRecentCache && 
      !isSuccessCase &&  
      !isSuccessQcCheck && 
      !isSuccessQcPass  
    ){
      dispatch({ 
        type: actionTypes.LISTS_CUSTOMER_SURVEY_UPDATE, 
        listsCustomerSurvey: {data:[],max:0}
      }) 
      return
    }  

    var send =  {}
    if(useRecentCache){
      send.leadName = _leadName
      send.limit = _limit
      send.status = _status
      send.dealer_code = dealer_code
    }else{
      var leadID_array = ""
      leadName.map((data,index)=>{
        if(index != 0){
          leadID_array += ","
        }
        leadID_array += data.value 
      }) 
      _leadName = leadID_array
      _limit = limit
      _status = status
      send = { leadName:leadID_array , limit:limit , status:status , dealer_code:dealer_code}
    } 

    if(Auth.isAuthentication() && Auth.getUserData().user_type_code == 6){
      send.isAgent = true
    }
    // if(isSuccessCase){
    //   APIPost(UrlServer.URL_POST_GET_CUSTOMERTELESURVEY_SUCCESS_CASE, send, datas => {
    //     dispatch({ 
    //       type: actionTypes.LISTS_CUSTOMER_SURVEY_UPDATE, 
    //       listsCustomerSurvey: {data:datas.datas,max:datas.max}
    //     }) 
    //   }) 
    // }
    // else if(isSuccessQcCheck){
    //   send.mode_name = "check"
    //   send.startdate = startDate
    //   send.enddate = endDate
    //   APIPost(UrlServer.URL_POST_GET_QC_CUSTOMERTELESURVEY, send, datas => {
    //     dispatch({ 
    //       type: actionTypes.LISTS_CUSTOMER_SURVEY_UPDATE, 
    //       listsCustomerSurvey: {data:datas.datas,max:datas.max}
    //     }) 
    //   }) 
    // }
    // else if(isSuccessQcPass){
    //   send.mode_name = "pass"
    //   send.startdate = startDate
    //   send.enddate = endDate
    //   APIPost(UrlServer.URL_POST_GET_QC_CUSTOMERTELESURVEY, send, datas => {
    //     dispatch({ 
    //       type: actionTypes.LISTS_CUSTOMER_SURVEY_UPDATE, 
    //       listsCustomerSurvey: {data:datas.datas,max:datas.max}
    //     }) 
    //   }) 
    // }
    // else{
      send.startdate = startDate
      send.enddate = endDate
      APIPost(UrlServer.URL_POST_GET_CUSTOMERTELESURVEY, send, datas => {
        dispatch({ 
          type: actionTypes.LISTS_CUSTOMER_SURVEY_UPDATE, 
          listsCustomerSurvey: {data:datas.datas,max:datas.max}
        }) 
      }) 
    // } 
  }
} 
